var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',{attrs:{"lg":"5"}},[_c('v-card',{attrs:{"outlined":""}},[_c('v-date-picker',{attrs:{"full-width":""},model:{value:(_vm.picker),callback:function ($$v) {_vm.picker=$$v},expression:"picker"}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }